import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=8fe06964&"
import script from "./offers.vue.ts?vue&type=script&lang=ts&"
export * from "./offers.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports